module.exports = __webpack_public_path__ + "static/media/peughouia.9c7c5953.jpg";